var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    _vm.to
      ? _c(
          "a",
          {
            class: _vm.linkClasses,
            attrs: { href: _vm.linkUrl, target: _vm.target },
            on: {
              click: [
                function($event) {
                  if (
                    $event.ctrlKey ||
                    $event.shiftKey ||
                    $event.altKey ||
                    $event.metaKey
                  ) {
                    return null
                  }
                  return _vm.handleCheckClick($event, false)
                },
                function($event) {
                  if (!$event.ctrlKey) {
                    return null
                  }
                  return _vm.handleCheckClick($event, true)
                },
                function($event) {
                  if (!$event.metaKey) {
                    return null
                  }
                  return _vm.handleCheckClick($event, true)
                }
              ]
            }
          },
          [_vm._t("default")],
          2
        )
      : _c("span", { class: _vm.linkClasses }, [_vm._t("default")], 2),
    _vm._v(" "),
    !_vm.showSeparator
      ? _c("span", {
          class: _vm.separatorClasses,
          domProps: { innerHTML: _vm._s(_vm.separator) }
        })
      : _c("span", { class: _vm.separatorClasses }, [_vm._t("separator")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5670852b", { render: render, staticRenderFns: staticRenderFns })
  }
}